import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f425fb9"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "star-activation-mask"
}
const _hoisted_2 = { class: "star-activation-dialog" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "star-activation-title" }, "权益激活提醒", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "star-activation-subtitle" }, "完成激活，即可使用以下权益：", -1))
const _hoisted_5 = { class: "star-activation-list" }
const _hoisted_6 = {
  key: 0,
  class: "star-activation-qr-wrap"
}
const _hoisted_7 = {
  ref: "qrRef",
  style: {"width":"120px","height":"120px"}
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "star-activation-qr-tip" }, "打开APP，进入\"我的订单-量化产品-待激活\"激活权益", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.visible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", {
            class: "star-activation-close",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
          }, "✕"),
          _hoisted_3,
          _hoisted_4,
          _createElementVNode("ul", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.benefits, (item) => {
              return (_openBlock(), _createElementBlock("li", { key: item }, _toDisplayString(item), 1))
            }), 128))
          ]),
          _createElementVNode("button", {
            class: "star-activation-btn",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('activate')))
          }, "立即激活"),
          _createElementVNode("div", {
            class: "star-activation-refresh",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('refresh')))
          }, "已激活，立即刷新"),
          (_ctx.showQr)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, null, 512),
                _hoisted_8
              ]))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}